export function dashboardMobileNav() {
    const $body = $("body");
    const $navOpener = $(".dashboard-nav-opener");
    const $navClose = $(".dashboard-navigation-close");
    const $menuHolder = $(".dashboard-navigation-holder");
    const $menu = $menuHolder.find("ul");
    $navOpener.html($menu.find(".is-active a").html());
    $navOpener.on("click", function (e) {
        e.preventDefault();
        $body.addClass("dashboard-menu-opened");
    });
    $navClose.on("click", function (e) {
        e.preventDefault();
        $body.removeClass("dashboard-menu-opened");
    });
    $menuHolder.on('click', function(e) {
        if (e.target !== this)
            return;

        $body.removeClass("dashboard-menu-opened");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/dashboardMobileNav.js